import { authHeader,logout, handleResponse } from '../helpers';
import Vue from 'vue';


export const zivalService = {
    load,loadAll,save,remove,loadPreteklaSezona
    
};

function load(sezona,pridelovalecid) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/zival/?sezona=${sezona}&pridelovalecid=${pridelovalecid}`, requestOptions)
        .then(handleResponse)
        .then(zival => {
            // login successful if there's a jwt token in the response
            
            return zival;
        });
}


function loadPreteklaSezona(sezona,pridelovalecid) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/zival/preteklasezona/?sezona=${sezona}&pridelovalecid=${pridelovalecid}`, requestOptions)
        .then(handleResponse)
        .then(zival => {
            // login successful if there's a jwt token in the response
            
            return zival;
        });
}

function save(zival) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(zival)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/zival`, requestOptions).then(handleResponse);
}


function remove(zival) {
    const requestOptions = {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(zival)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/zival`, requestOptions).then(handleResponse);
}

function loadAll(sezona){
  const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


     return fetch(`${Vue.prototype.$config.apiUrl}/zival/vse/?sezona=${sezona}`, requestOptions)
        .then(handleResponse)
        .then(zival => {
            // login successful if there's a jwt token in the response
            
            return zival;
        });
}

function loadLastYear(gerk,status){
    //in tu lahko napišem pravila ali pa jih enostavno potegnem iz baze preko api-ja
    return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/pridelovalec/zival/?sezona=${sezona}&pridelovalecid=${pridelovalecid}`, requestOptions)
        .then(handleResponse)
        .then(zival => {
            // login successful if there's a jwt token in the response
            
            return zival;
        });

}
